import { NewsletterSubscribe } from './NewsletterSubscribe';
import { ContactUs } from './ContactUs';

export const Sitewide = {
    NewsletterSubscribe,
    ContactUs,
}
